export function resolveStudioAgentAlias(
  name: string | undefined,
  agentId: string,
): string {
  const alias = (name || agentId)
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return alias || agentId;
}

export function formatStudioThreadOptionLabel(
  thread: { id: string; title?: string | null },
  siblings: Array<{ id: string; title?: string | null }>,
): string {
  const title = thread.title?.trim() || thread.id;
  const duplicateTitleCount = siblings.filter(
    (candidate) => (candidate.title?.trim() || candidate.id) === title,
  ).length;
  if (duplicateTitleCount <= 1) {
    return title;
  }
  return `${title} · ${thread.id.slice(-6)}`;
}
